/* @ts-nocheck */
/* eslint-disable */
(function ($) {
  function applyFullScreenWrapHeight($wrap) {
    var bar = document.querySelector('.announcement-bar');
    var barHeight = bar ? bar.offsetHeight : 0;
    $wrap.css('height', 'calc(100vh - ' + barHeight + 'px)');
    $wrap.css('height', 'calc(100svh - ' + barHeight + 'px)');
  }

  function initHeroCarousels() {
    $('.c21-hero-carousel').each(function () {
      var $carousel = $(this);

      if ($carousel.hasClass('slick-initialized')) return;

      var $wrap = $carousel.closest('.c21-hero-carousel-wrap');
      var isFullScreen = $wrap.data('full-screen') === true || $wrap.data('full-screen') === 'true';
      var autoplay = $carousel.data('autoplay') === true || $carousel.data('autoplay') === 'true';
      var autoplaySpeed = parseInt($carousel.data('autoplay-speed'), 10) || 5000;
      var pauseOnHover = !(($carousel.data('pause-on-hover') === false) || ($carousel.data('pause-on-hover') === 'false'));
      var scrollFullView = $carousel.data('scroll-full-view') === true || $carousel.data('scroll-full-view') === 'true';
      var slidesToShow = parseInt($carousel.data('slides-to-show'), 10) || 4;
      var slidesToShowMobile = parseInt($carousel.data('slides-to-show-mobile'), 10) || 1;

      function applyOverflow() {
        $carousel.find('.slick-list').css('overflow', 'visible');
      }

      $carousel.on('init breakpoint reInit', applyOverflow);

      if (isFullScreen) {
        applyFullScreenWrapHeight($wrap);
      }

      $carousel.slick({
        mobileFirst: true,
        slidesToShow: slidesToShowMobile,
        slidesToScroll: scrollFullView ? slidesToShowMobile : 1,
        infinite: true,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        pauseOnHover: pauseOnHover,
        arrows: false,
        dots: false,
        swipe: true,
        draggable: false,
        touchThreshold: 10,
        adaptiveHeight: false,
        fade: false,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: slidesToShow,
              slidesToScroll: scrollFullView ? slidesToShow : 1
            }
          }
        ]
      });

      function scrollToNextFold() {
        var target = window.innerHeight;
        var $heroContent = $wrap.nextAll('.hero-content').first();
        if (!$heroContent.length) {
          $heroContent = $wrap.nextAll().find('.hero-content').first();
        }
        if ($heroContent.length) {
          var rect = $heroContent[0].getBoundingClientRect();
          var marginTop = parseFloat(window.getComputedStyle($heroContent[0]).marginTop) || 0;
          target = rect.top + window.scrollY - marginTop;
        }
        window.scrollTo({ top: target, behavior: 'smooth' });
      }

      var $readMore = $wrap.find('.c21-hero-readmore-link');
      if ($readMore.length) {
        $readMore.on('click', function (e) {
          e.preventDefault();
          if (isFullScreen) scrollToNextFold();
        });
      }

      if (isFullScreen) {
        var wheelLocked = false;
        $wrap[0].addEventListener('wheel', function (e) {
          if (window.innerWidth <= 750) return;
          if (e.deltaY > 0 && window.scrollY < window.innerHeight) {
            e.preventDefault();
            if (wheelLocked) return;
            wheelLocked = true;
            scrollToNextFold();
            setTimeout(function () { wheelLocked = false; }, 800);
          }
        }, { passive: false });

        var mousedownX, mousedownY;
        $wrap[0].addEventListener('mousedown', function (e) {
          mousedownX = e.clientX;
          mousedownY = e.clientY;
        });
        $wrap[0].addEventListener('mouseup', function (e) {
          var dx = Math.abs(e.clientX - mousedownX);
          var dy = Math.abs(e.clientY - mousedownY);
          if (dx < 5 && dy < 5 && window.scrollY < window.innerHeight) {
            scrollToNextFold();
          }
        });
      }
    });
  }

  $(function () {
    initHeroCarousels();
  });

  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $('.c21-hero-carousel-wrap[data-full-screen="true"]').each(function () {
        applyFullScreenWrapHeight($(this));
      });
      $('.c21-hero-carousel.slick-initialized').each(function () {
        $(this).slick('setPosition');
        $(this).find('.slick-list').css('overflow', 'visible');
      });
    }, 150);
  });

  document.addEventListener('shopify:section:load', function () {
    initHeroCarousels();
    $('.c21-hero-carousel-wrap[data-full-screen="true"]').each(function () {
      applyFullScreenWrapHeight($(this));
    });
    $('.c21-hero-carousel.slick-initialized').each(function () {
      $(this).slick('setPosition');
      $(this).find('.slick-list').css('overflow', 'visible');
    });
  });
})(jQuery);
